import './index.less'
import { isMobile } from '@utils/index.js'
export class QualitySwiper {
    constructor(){
        this.init()
    }
    init(){
        const qualityIntroSwiper = $('.quality-introduction');
        if (qualityIntroSwiper.length === 0) return;
        qualityIntroSwiper.each(function(){
            const className = $(this).attr('class');
            const match = className.match(/quality-introduction-(\S+)/);
            const index = match ? match[1] : $(this).data('index');

            const currentComponent = `.quality-introduction-${index}`;
            const currentSwiper =  $(`${currentComponent} .quality-introduction-swiper`);
            // 创建Swiper实例并保存引用
            new Swiper(currentSwiper[0], {
                spaceBetween: !isMobile() ? 16 : 24,
                slidesPerView: !isMobile() ? 1.37 : 1.3,
                slideToClickedSlide: true,
                autoplay: false,
                freeMode: false,
                loop: true,
                lazy: true,
                navigation: {
                    prevEl: `.quality-introduction-${index} .swiper-activity-button-prev`,
                    nextEl: `.quality-introduction-${index} .swiper-activity-button-next`
                },
                pagination: {
                    el: `${currentComponent} .quality-pagination`,
                    clickable: true
                }
            });
        })
    }
}
